import { render, staticRenderFns } from "./ChangeConfirmation.vue?vue&type=template&id=52861222&scoped=true"
import script from "./ChangeConfirmation.vue?vue&type=script&lang=js"
export * from "./ChangeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ChangeConfirmation.vue?vue&type=style&index=0&id=52861222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52861222",
  null
  
)

export default component.exports